// Kalite Yönetimi sayfası ve pencereleri. Kayıtlara yazılan değerler (grup /
// rol adları, CAPA tipi-durumu, bildirim tipi-önceliği, politika kategorisi)
// Türkçe kalır; profil bu değerlerle eşleştirir. Burada yalnızca ekrandaki
// metinler var.
const quality = {
  page: {
    title: 'Kalite Yönetimi',
    subtitle: 'Prosedürler, politikalar, formlar, eğitimler ve kalite kayıtları tek yerde.',
    open: 'Aç',
    help: {
      profile: 'SOP, politika, görev tanımı, form ve endikasyon eğitimleri seçtiğiniz departmanlara atanır; o departmandaki çalışanlar bunları Profil › Dosyalar sekmesinde görür. “Hepsi” seçilirse tüm çalışanlara görünür.',
      care: 'Burada yaptığınız ekleme, düzenleme ve silme işlemleri çalışanların profiline anında yansır. Yanlış departmana atamamak için kaydetmeden önce grupları kontrol edin.',
    },
    badges: {
      profile: 'Profilde görünür',
      quiz: 'Profil sınavlarını besler',
    },
    sections: {
      documents: {
        title: 'Doküman Kütüphanesi',
        text: 'Departmanlara atanan ve çalışanların profilinde listelenen belgeler.',
      },
      training: {
        title: 'Eğitim ve Sınavlar',
        text: 'Video eğitimler, okuma sonu sınav soruları ve atamaların takibi.',
      },
      records: {
        title: 'Kalite Kayıtları',
        text: 'Düzeltici / önleyici faaliyetler ve kalite bildirimleri. Bu kayıtlar yalnızca burada tutulur, profilde görünmez.',
      },
    },
    modules: {
      sop: { title: 'SOP', text: 'Standart operasyon prosedürleri; okuma onaylarını ve okuyanları takip edin.' },
      policy: { title: 'Politikalar', text: 'Şirket politikaları ve yönergeleri; kategori ve versiyonlarıyla.' },
      jobDescription: { title: 'Görev Tanımları', text: 'Pozisyonların rol ve sorumluluk tanımları.' },
      forms: { title: 'Formlar', text: 'Standart form ve belge şablonları; tek tıkla açın veya indirin.' },
      education: { title: 'Endikasyon Eğitim Modülü', text: 'Bölümleri ve sınavları olan video eğitimler oluşturun.' },
      questionPool: { title: 'Soru Havuzu', text: 'Departman bazlı SOP ve eğitim okuma sonu sınav soruları.' },
      assignments: { title: 'Atama Görüntüleme', text: 'SOP ve eğitim atamalarını, son tarihleri ve tamamlama durumunu görün.' },
      capa: { title: 'CAPA', text: 'Düzeltici ve önleyici faaliyetlerin kaydı ve takibi.' },
      notification: { title: 'Bildirimler', text: 'Sistem, kalite ve güvenlik bildirimleri; öncelik ve son tarihleriyle.' },
    },
  },

  common: {
    close: 'Kapat',
    cancel: 'Vazgeç',
    save: 'Kaydet',
    saving: 'Kaydediliyor...',
    adding: 'Ekleniyor...',
    updating: 'Güncelleniyor...',
    edit: 'Düzenle',
    delete: 'Sil',
    deleteConfirm: 'Evet, sil',
    deleteMessage: '“{{name}}” kalıcı olarak silinecek. Bu işlem geri alınamaz.',
    loading: 'Yükleniyor...',
    choose: 'Seçin',
    na: 'Belirtilmemiş',
    notAssigned: 'Atanmamış',
    openFile: 'Dosyayı aç',
    groups: 'Atanacak gruplar',
    groupsHint: 'Seçilen departmanlardaki çalışanlar bu kaydı profilinde görür. “Hepsi” tüm çalışanlar demektir.',
    audience: 'İlgili personel',
    audienceHint: 'İsteğe bağlı · yalnızca bilgi amaçlıdır, profildeki görünürlüğü değiştirmez.',
  },

  groupsPicker: {
    selected_one: '{{count}} seçili',
    selected_other: '{{count}} seçili',
  },

  groups: {
    all: 'Hepsi',
    siteCoordinator: 'Saha Koordinatörü',
    researchNurse: 'Klinik Araştırma Hemşiresi',
    projectManager: 'Proje Müdürü',
    startupLead: 'Çalışma Başlatma Sorumlusu',
    backup: 'Backup Personeli',
    cra: 'CRA',
    qualityManager: 'Kalite Müdürü',
    finance: 'Finans Uzmanı',
    it: 'IT Uzmanı',
    hr: 'İK Uzmanı',
    bizDev: 'İş Geliştirme Uzmanı',
    training: 'Eğitim Sorumlusu',
  },

  file: {
    choose: 'Dosya seçilmedi',
    dropHint: 'Dosyayı seçin veya buraya sürükleyin',
    pick: 'Dosya seç',
    change: 'Değiştir',
    current: 'Yeni dosya seçilmedi',
    viewCurrent: 'Mevcut dosyayı görüntüle',
  },

  validation: {
    sopName: 'Lütfen SOP adını girin',
    sopFileType: 'Yalnızca PDF, MP4 ve PowerPoint (.ppt, .pptx) dosyaları yükleyebilirsiniz',
    dueDate: 'Lütfen son tamamlama tarihini girin',
    approvalDate: 'Lütfen onay tarihini girin',
    version: 'Lütfen versiyon numarasını girin',
    category: 'Lütfen kategori seçin',
    policyName: 'Lütfen politika adını girin',
    file: 'Lütfen bir dosya yükleyin',
    group: 'Lütfen en az bir grup seçin',
    dofNo: 'Lütfen DÖF numarasını girin',
    dofNoTaken: 'Bu DÖF numarası başka bir kayıtta kullanılıyor',
    dofSource: 'Lütfen uygunsuzluğun kaynağını seçin',
    dofSourceOther: 'Lütfen “Diğer” kaynağı yazın',
    nonconformity: 'Lütfen tespit edilen uygunsuzluğu yazın',
    reporter: 'Lütfen bildirenin adını soyadını girin',
    capaType: 'Lütfen faaliyet tipini seçin (düzeltici / önleyici)',
    capaStatus: 'Lütfen CAPA durumunu seçin',
    createdDate: 'Lütfen oluşturma tarihini girin',
    notificationTitle: 'Lütfen bildirim başlığını girin',
    notificationType: 'Lütfen bildirim tipini seçin',
    priority: 'Lütfen öncelik seviyesini seçin',
    date: 'Lütfen tarihi girin',
    jobTitle: 'Lütfen görev tanımı başlığını girin',
    position: 'Lütfen pozisyonu girin',
    educationTitle: 'Lütfen eğitim başlığını girin',
    educationDescription: 'Lütfen eğitim açıklamasını girin',
    video: 'Lütfen bir video dosyası seçin',
    chapterTitles: 'Tüm bölümlerin başlığı olmalıdır',
    popQuestions: 'Tüm pop quiz sorularını doldurun',
    popOptions: 'Tüm pop quiz seçeneklerini doldurun',
    finalQuestions: 'Tüm final quiz sorularını doldurun',
    finalOptions: 'Tüm final quiz seçeneklerini doldurun',
    targetGroup: 'En az bir hedef grup seçin',
  },

  sop: {
    title: 'SOP Yönetimi',
    subtitle_one: '{{count}} SOP · departman klasörlerine göre',
    subtitle_other: '{{count}} SOP · departman klasörlerine göre',
    help: 'Klasörler departmanları gösterir; bir SOP birden fazla departmana atanabilir. Kişiler simgesiyle SOP’u kimlerin okuduğunu görebilirsiniz.',
    add: 'Yeni SOP',
    search: 'SOP adı veya versiyon ara...',
    folders: 'Departman klasörleri',
    all: 'Tüm SOP’ler',
    ungrouped: 'Grupsuz',
    count_one: '{{count}} SOP',
    count_other: '{{count}} SOP',
    emptyFolder: 'Bu klasörde SOP yok',
    noMatch: 'Aramanızla eşleşen SOP bulunamadı',
    readers: 'Okuyanları gör',
    deleteTitle: 'SOP silinsin mi?',
    addTitle: 'Yeni SOP',
    editTitle: 'SOP’u Düzenle',
    formSubtitle: 'Standart operasyon prosedürü',
    formHelp: 'Seçtiğiniz gruplardaki çalışanlar SOP’u profilinde görür ve okuma onayı verir. Son tamamlama tarihi profilde hatırlatma olarak gösterilir.',
    columns: {
      name: 'SOP Adı',
      version: 'Versiyon',
      approvalDate: 'Onay Tarihi',
      dueDate: 'Son Tamamlama',
    },
    fields: {
      name: 'SOP adı',
      namePlaceholder: 'Örn. Bilgilendirilmiş Onam Süreci',
      version: 'Versiyon numarası',
      versionPlaceholder: 'Örn. 2.0',
      approvalDate: 'Onay tarihi',
      dueDate: 'Son tamamlama tarihi',
      dueDateHint: 'Çalışanların SOP’u bu tarihe kadar okuması beklenir.',
      file: 'SOP dosyası',
      fileHint: 'PDF, MP4 veya PowerPoint (.ppt, .pptx)',
    },
    toast: {
      loadError: 'SOP bilgileri alınırken bir hata oluştu',
      added: 'SOP başarıyla eklendi',
      addError: 'SOP eklenirken bir hata oluştu',
      updated: 'SOP başarıyla güncellendi',
      updateError: 'SOP güncellenirken bir hata oluştu',
      deleted: 'SOP başarıyla silindi',
      deleteError: 'SOP silinirken bir hata oluştu',
    },
  },

  readers: {
    title: 'SOP Okuyanları',
    sopName: 'SOP',
    version: 'Versiyon',
    groups: 'Atanan gruplar',
    stats: {
      readers: 'Okuyan',
      employees: 'Toplam çalışan',
      rate: 'Okuma oranı',
    },
    help: 'Okuma onayı veren çalışanlar listelenir. Oran, sistemdeki tüm çalışanlara göre hesaplanır.',
    empty: 'Henüz kimse okuma onayı vermedi',
    read: 'Okundu',
    titleLabel: 'Ünvan',
    department: 'Departman',
    readAt: 'Okuma tarihi',
    unknown: 'Bilinmeyen kullanıcı',
    toast: {
      loadError: 'Okuyucu bilgileri alınırken bir hata oluştu',
    },
  },

  policy: {
    title: 'Politikalar',
    subtitle_one: '{{count}} politika',
    subtitle_other: '{{count}} politika',
    help: 'Politikalar seçilen departmanlara atanır ve çalışanların profilinde görünür. Satırdaki simgelerle dosyayı açabilir, kaydı düzenleyebilir veya silebilirsiniz.',
    add: 'Yeni Politika',
    search: 'Politika adı, kategori veya versiyon ara...',
    empty: 'Henüz politika eklenmedi',
    noMatch: 'Aramanızla eşleşen politika bulunamadı',
    deleteTitle: 'Politika silinsin mi?',
    addTitle: 'Yeni Politika',
    editTitle: 'Politikayı Düzenle',
    formSubtitle: 'Şirket politikası ve yönergesi',
    formHelp: 'Seçtiğiniz gruplardaki çalışanlar politikayı profilinde görür.',
    categories: {
      quality: 'Kalite',
      hr: 'İnsan Kaynakları',
      infoSec: 'Bilgi Güvenliği',
      health: 'Sağlık ve Güvenlik',
      environment: 'Çevre',
      general: 'Genel',
    },
    columns: {
      name: 'Politika Adı',
      category: 'Kategori',
      version: 'Versiyon',
      approvalDate: 'Onay Tarihi',
      groups: 'Gruplar',
    },
    fields: {
      name: 'Politika adı',
      namePlaceholder: 'Örn. Bilgi Güvenliği Politikası',
      category: 'Kategori',
      version: 'Versiyon numarası',
      versionPlaceholder: 'Örn. 1.0',
      approvalDate: 'Onay tarihi',
      description: 'Açıklama',
      descriptionPlaceholder: 'Politikanın kapsamını kısaca yazın',
      file: 'Politika dosyası',
      fileHint: 'PDF veya Word (.doc, .docx)',
    },
    toast: {
      loadError: 'Politika bilgileri alınırken bir hata oluştu',
      added: 'Politika başarıyla eklendi',
      addError: 'Politika eklenirken bir hata oluştu',
      updated: 'Politika başarıyla güncellendi',
      updateError: 'Politika güncellenirken bir hata oluştu',
      deleted: 'Politika başarıyla silindi',
      deleteError: 'Politika silinirken bir hata oluştu',
    },
  },

  jobDescription: {
    title: 'Görev Tanımları',
    subtitle_one: '{{count}} görev tanımı',
    subtitle_other: '{{count}} görev tanımı',
    help: 'Görev tanımları seçilen departmanlara atanır ve o çalışanların profilinde görünür.',
    add: 'Yeni Görev Tanımı',
    search: 'Başlık veya pozisyon ara...',
    empty: 'Henüz görev tanımı eklenmedi',
    noMatch: 'Aramanızla eşleşen görev tanımı bulunamadı',
    deleteTitle: 'Görev tanımı silinsin mi?',
    addTitle: 'Yeni Görev Tanımı',
    editTitle: 'Görev Tanımını Düzenle',
    formSubtitle: 'Pozisyonun rol ve sorumlulukları',
    formHelp: 'Seçtiğiniz gruplardaki çalışanlar görev tanımını profilinde görür.',
    columns: {
      title: 'Başlık',
      position: 'Pozisyon',
      createdDate: 'Oluşturma Tarihi',
      groups: 'Gruplar',
    },
    fields: {
      title: 'Başlık',
      titlePlaceholder: 'Örn. Saha Koordinatörü Görev Tanımı',
      position: 'Pozisyon',
      positionPlaceholder: 'Örn. Saha Koordinatörü',
      createdDate: 'Oluşturma tarihi',
      description: 'Açıklama',
      descriptionPlaceholder: 'Rolün temel sorumluluklarını kısaca yazın',
      file: 'Görev tanımı dosyası',
      fileHint: 'PDF veya Word (.doc, .docx)',
    },
    toast: {
      loadError: 'Görev tanımı bilgileri alınırken bir hata oluştu',
      added: 'Görev tanımı başarıyla eklendi',
      addError: 'Görev tanımı eklenirken bir hata oluştu',
      updated: 'Görev tanımı başarıyla güncellendi',
      updateError: 'Görev tanımı güncellenirken bir hata oluştu',
      deleted: 'Görev tanımı başarıyla silindi',
      deleteError: 'Görev tanımı silinirken bir hata oluştu',
    },
  },

  forms: {
    title: 'Formlar',
    subtitle_one: '{{count}} form',
    subtitle_other: '{{count}} form',
    help: 'Bir satıra tıklayınca form dosyası yeni sekmede açılır; indirme simgesiyle bilgisayarınıza kaydedebilirsiniz. Formlar seçilen departmanların profilinde görünür.',
    add: 'Yeni Form',
    search: 'Form adı, kategori veya grup ara...',
    empty: 'Henüz form eklenmedi',
    noMatch: 'Aramanızla eşleşen form bulunamadı',
    rowOpen: 'Formu yeni sekmede aç',
    rowNoFile: 'Bu form için dosya yok',
    download: 'Dosyayı indir',
    deleteTitle: 'Form silinsin mi?',
    addTitle: 'Yeni Form',
    editTitle: 'Formu Düzenle',
    formSubtitle: 'Standart form ve belge şablonu',
    formHelp: 'Seçtiğiniz gruplardaki çalışanlar formu profilinde görür ve indirebilir.',
    groupsLocked: 'Atanan gruplar bu pencereden değiştirilemez. Grupları değiştirmek için formu silip doğru gruplarla yeniden ekleyin.',
    columns: {
      name: 'Form Adı',
      category: 'Kategori',
      version: 'Versiyon',
      approvalDate: 'Onay Tarihi',
      groups: 'Gruplar',
    },
    fields: {
      name: 'Form adı',
      namePlaceholder: 'Örn. Advers Olay Bildirim Formu',
      category: 'Kategori',
      categoryPlaceholder: 'Örn. Klinik',
      version: 'Versiyon',
      versionPlaceholder: 'Örn. 1.0',
      uploadDate: 'Yükleme tarihi',
      file: 'Form dosyası',
      fileHint: 'PDF, Word veya Excel',
    },
    toast: {
      loadError: 'Form bilgileri alınırken bir hata oluştu',
      added: 'Form başarıyla eklendi',
      addError: 'Form eklenirken bir hata oluştu',
      updated: 'Form başarıyla güncellendi',
      updateError: 'Form güncellenirken bir hata oluştu',
      deleted: 'Form başarıyla silindi',
      deleteError: 'Form silinirken bir hata oluştu',
      downloading: 'Dosya indiriliyor...',
      noFile: 'Dosya bulunamadı',
      formHasNoFile: 'Bu form için dosya bulunmamaktadır',
    },
  },

  capa: {
    title: 'CAPA',
    subtitle_one: '{{count}} düzeltici / önleyici faaliyet',
    subtitle_other: '{{count}} düzeltici / önleyici faaliyet',
    help: 'Düzeltici (Corrective) ve önleyici (Preventive) faaliyetleri durumlarıyla takip edin. Kapanan kayıtları “Kapalı” durumuna alın. CAPA kayıtları profilde görünmez.',
    add: 'Yeni CAPA',
    search: 'Uygunsuzluk, DÖF No, tip veya durum ara...',
    empty: 'Henüz CAPA kaydı yok',
    noMatch: 'Aramanızla eşleşen CAPA bulunamadı',
    deleteTitle: 'CAPA silinsin mi?',
    addTitle: 'Yeni CAPA',
    editTitle: 'CAPA’yı Düzenle',
    formSubtitle: 'Düzeltici veya önleyici faaliyet',
    viewTitle: 'DÖF Formu',
    viewForm: 'DÖF formunu görüntüle',
    stepsLabel: 'DÖF formu adımları',
    back: 'Geri',
    next: 'İleri',
    preview: 'Önizle',
    steps: {
      detection: 'Uygunsuzluk tespiti',
      unit: 'Birim amiri',
      result: 'Sonuç ve takip',
      preview: 'Önizleme',
    },
    intro: {
      detection: 'DÖF formunun ilk bölümü: uygunsuzluğu tespit eden kişi tarafından doldurulur. DÖF No otomatik önerilir, gerekirse değiştirebilirsiniz.',
      unit: 'Bu bölüm ilgili birim amirince doldurulur. Şimdi boş bırakıp kök neden analizi ve öneriler netleşince kaydı düzenleyerek tamamlayabilirsiniz.',
      result: 'Faaliyetin sonucu ve portaldaki takip bilgileri. Sonuç değerlendirmesi genellikle faaliyet kapatılırken işaretlenir; seçime tekrar dokunmak onu kaldırır.',
      preview: 'Kaydetmeden önce formu kontrol edin. Düzeltmek için “Geri” ile ilgili adıma dönün; her şey doğruysa “Kaydet”e basın.',
    },
    types: {
      corrective: 'Düzeltici Faaliyet',
      preventive: 'Önleyici Faaliyet',
    },
    statuses: {
      open: 'Açık',
      ongoing: 'Devam Ediyor',
      closed: 'Kapalı',
    },
    sources: {
      internalAudit: 'İç Denetim Uygunsuzluğu',
      externalAudit: 'Dış Denetim Uygunsuzluğu',
      employeeDissatisfaction: 'Çalışan Memnuniyetsizliği',
      performance: 'Performans Değerlendirme',
      calibration: 'Kalibrasyon Uygunsuzluğu',
      safety: 'İş Güvenliği Uygunsuzluğu',
      complaint: 'Hizmet Alan Şikayet',
      serviceFlow: 'Hizmet İşleyişi',
      other: 'Diğer',
    },
    results: {
      A: 'A - Gerçekleştirilen faaliyet uygunsuzluğun tekrarını önlemek için yeterli olmuştur',
      B: 'B - Gerçekleştirilen faaliyet uygunsuzluğun tekrarını önlemek için yeterli olmamıştır',
    },
    columns: {
      name: 'Tespit Edilen Uygunsuzluk',
      dofNo: 'DÖF No',
      type: 'Tip',
      status: 'Durum',
      createdDate: 'Tarih',
      dueDate: 'Son Tamamlama',
    },
    fields: {
      type: 'Faaliyet tipi',
      dofNo: 'DÖF No',
      dofNoHint: 'Yıl içindeki sıradaki numara önerilir.',
      createdDate: 'Tarih',
      sources: 'Uygunsuzluğun kaynağı',
      sourceOther: 'Diğer kaynak',
      sourceOtherPlaceholder: 'Kaynağı kısaca yazın',
      nonconformity: 'Tespit edilen uygunsuzluk / potansiyel uygunsuzluk',
      nonconformityPlaceholder: 'Örn. Ziyaret sonrası kaynak doküman dosyada bulunmuyor',
      definition: 'Uygunsuzluğun tanımı',
      definitionPlaceholder: 'Uygunsuzluğu, karşılanmayan şartla birlikte tanımlayın',
      location: 'Uygunsuzluk yeri',
      locationPlaceholder: 'Örn. Ankara Şehir Hastanesi · Onkoloji',
      reporter: 'Uygunsuzluğu bildirenin adı soyadı',
      rootCause: 'Uygunsuzluğun muhtemel kök neden analizi',
      correctiveProposal: 'Gerçekleştirilecek düzeltici faaliyet önerisi',
      preventiveProposal: 'Gerçekleştirilecek önleyici faaliyet önerisi',
      monitoring: 'İzleme ve değerlendirme',
      responsible: 'Düzeltici / önleyici faaliyet için belirlenen sorumlunun adı soyadı',
      resultNote: 'Sonuç açıklaması',
      result: 'Sonuç değerlendirmesi',
      status: 'Durum',
      dueDate: 'Son tamamlama tarihi',
      dueDateHint: 'Faaliyetin kapatılması beklenen tarih.',
      file: 'Ek dosya',
      fileHint: 'İsteğe bağlı · PDF, Word veya Excel',
    },
    toast: {
      loadError: 'CAPA bilgileri alınırken bir hata oluştu',
      added: 'CAPA başarıyla eklendi',
      addError: 'CAPA eklenirken bir hata oluştu',
      updated: 'CAPA başarıyla güncellendi',
      updateError: 'CAPA güncellenirken bir hata oluştu',
      deleted: 'CAPA başarıyla silindi',
      deleteError: 'CAPA silinirken bir hata oluştu',
    },
  },

  notification: {
    title: 'Bildirimler',
    subtitle_one: '{{count}} bildirim',
    subtitle_other: '{{count}} bildirim',
    help: 'Sistem, kalite, güvenlik ve genel bildirimleri öncelik ve son tarihleriyle kaydedin. Bu kayıtlar profilde görünmez.',
    add: 'Yeni Bildirim',
    search: 'Başlık, tip veya öncelik ara...',
    empty: 'Henüz bildirim yok',
    noMatch: 'Aramanızla eşleşen bildirim bulunamadı',
    deleteTitle: 'Bildirim silinsin mi?',
    addTitle: 'Yeni Bildirim',
    editTitle: 'Bildirimi Düzenle',
    formSubtitle: 'Kalite bildirimi',
    formHelp: 'Tip ve önceliği seçin. Son tarih, bildirimle ilgili işlemin tamamlanması beklenen tarihtir.',
    types: {
      system: 'Sistem',
      quality: 'Kalite',
      security: 'Güvenlik',
      general: 'Genel',
    },
    priorities: {
      high: 'Yüksek',
      medium: 'Orta',
      low: 'Düşük',
    },
    columns: {
      title: 'Başlık',
      type: 'Tip',
      priority: 'Öncelik',
      date: 'Tarih',
      dueDate: 'Son Tarih',
    },
    fields: {
      title: 'Başlık',
      titlePlaceholder: 'Örn. Sistem bakımı',
      type: 'Tip',
      priority: 'Öncelik',
      date: 'Tarih',
      dueDate: 'Son tarih',
      dueDateHint: 'Bildirimle ilgili işlemin tamamlanması beklenen tarih.',
      description: 'Açıklama',
      descriptionPlaceholder: 'Bildirimin ayrıntılarını yazın',
      file: 'Ek dosya',
      fileHint: 'İsteğe bağlı · PDF, Word veya Excel',
    },
    toast: {
      loadError: 'Bildirim bilgileri alınırken bir hata oluştu',
      added: 'Bildirim başarıyla eklendi',
      addError: 'Bildirim eklenirken bir hata oluştu',
      updated: 'Bildirim başarıyla güncellendi',
      updateError: 'Bildirim güncellenirken bir hata oluştu',
      deleted: 'Bildirim başarıyla silindi',
      deleteError: 'Bildirim silinirken bir hata oluştu',
    },
  },

  education: {
    title: 'Endikasyon Eğitim Modülü',
    subtitle_one: '{{count}} eğitim',
    subtitle_other: '{{count}} eğitim',
    help: 'Eğitimler hedef gruplardaki çalışanların profilinde görünür; çalışanlar videoyu izler, pop quiz ve final sınavını çözer. Son tarihi geçen eğitimler “Süresi doldu” olarak işaretlenir.',
    add: 'Yeni Eğitim',
    search: 'Eğitim adı veya eğitmen ara...',
    empty: 'Henüz eğitim eklenmedi',
    noMatch: 'Aramanızla eşleşen eğitim bulunamadı',
    watchVideo: 'Videoyu izle',
    chapterCount_one: '{{count}} bölüm',
    chapterCount_other: '{{count}} bölüm',
    popCount_one: '{{count}} pop quiz',
    popCount_other: '{{count}} pop quiz',
    finalCount_one: '{{count}} final sorusu',
    finalCount_other: '{{count}} final sorusu',
    expired: 'Süresi doldu',
    deleteTitle: 'Eğitim silinsin mi?',
    difficulty: {
      beginner: 'Başlangıç',
      intermediate: 'Orta',
      advanced: 'İleri',
    },
    columns: {
      title: 'Eğitim',
      content: 'İçerik',
      duration: 'Video süresi',
      difficulty: 'Seviye',
      groups: 'Hedef Gruplar',
      dueDate: 'Son Tamamlama',
      deadline: 'Erişim Son Tarihi',
    },
    toast: {
      loadError: 'Eğitim bilgileri alınırken bir hata oluştu',
      deleted: 'Eğitim başarıyla silindi',
      deleteError: 'Eğitim silinirken bir hata oluştu',
    },
  },

  educationForm: {
    addTitle: 'Yeni Eğitim',
    addSubtitle: 'Adım adım video eğitim oluşturun',
    editTitle: 'Eğitimi Düzenle',
    editSubtitle: 'Endikasyon eğitimi',
    stepsLabel: 'Eğitim oluşturma adımları',
    steps: {
      basic: 'Temel Bilgiler',
      video: 'Video',
      chapters: 'Bölümler',
      quizzes: 'Sınavlar',
      settings: 'Hedef ve Süre',
      settingsPublish: 'Hedef ve Yayın',
      summary: 'Özet',
    },
    intro: {
      basic: {
        title: 'Eğitimi tanıtın',
        text: 'Başlık, açıklama ve son tamamlama tarihi zorunludur. Diğer alanlar çalışanların eğitimi tanımasına yardımcı olur.',
        editText: 'Eğitimin başlığını, açıklamasını ve tarihlerini güncelleyin. Video düzenlemede değiştirilemez.',
      },
      video: {
        title: 'Eğitim videosunu yükleyin',
        text: 'Videoyu seçin; süresi otomatik okunur ve bölümler ile pop quizler bu süreye göre yerleştirilir.',
      },
      chapters: {
        title: 'Videoyu bölümlere ayırın',
        text: 'Her bölüme bir başlık ve başlangıç / bitiş zamanı verin. Çalışanlar bölümler arasında gezinebilir.',
        editText: 'Bölüm başlıklarını ve zamanlarını güncelleyin.',
      },
      quizzes: {
        title: 'Sınavları hazırlayın',
        text: 'Pop quizler video sırasında belirlediğiniz anda çıkar; final sınavı video bitince gösterilir ve geçme puanı ister.',
        editText: 'Pop quiz ve final sınavı sorularını güncelleyin.',
      },
      settings: {
        title: 'Kimler görecek?',
        text: 'Hedef grupları seçin; eğitim bu departmanlardaki çalışanların profilinde görünür. İsterseniz erişim için son tarih koyun, ardından yayınlayın.',
        editText: 'Hedef grupları ve erişim son tarihini güncelleyin.',
      },
      summary: {
        title: 'Kontrol edin ve kaydedin',
        editText: 'Değişiklikleri son kez gözden geçirip kaydedin.',
      },
    },
    title: 'Eğitim başlığı',
    titlePlaceholder: 'Örn. Atopik Dermatit Endikasyon Eğitimi',
    instructor: 'Eğitmen',
    instructorPlaceholder: 'Eğitmenin adı',
    category: 'Kategori',
    categoryPlaceholder: 'Örn. Dermatoloji',
    description: 'Açıklama',
    descriptionPlaceholder: 'Eğitimin amacını ve kapsamını kısaca yazın',
    estimatedDuration: 'Tahmini süre',
    estimatedDurationPlaceholder: 'Örn. 45 dakika',
    difficulty: 'Seviye',
    dueDate: 'Son tamamlama tarihi',
    dueDateHint: 'Çalışanların eğitimi bu tarihe kadar tamamlaması beklenir; profilde hatırlatılır.',
    existingVideo: 'Eğitim videosu yüklü',
    duration: 'Süre: {{time}}',
    videoLocked: 'Video düzenlemede değiştirilemez',
    videoHelp: 'Video yüklendikten sonra süresi otomatik okunur. Yayınlama sırasında yükleme ilerlemesi gösterilir; pencereyi kapatmayın.',
    pickVideo: 'Eğitim videosunu seçin',
    videoFormats: 'MP4, MOV, WebM gibi video dosyaları',
    changeVideo: 'Videoyu değiştir',
    chaptersHelp: 'Zamanları dakika:saniye olarak girin. Bölümler videonun tamamını kapsamak zorunda değildir.',
    chapterTitle: 'Bölüm başlığı',
    chapterTitlePlaceholder: 'Örn. Giriş',
    start: 'Başlangıç',
    end: 'Bitiş',
    addChapter: 'Bölüm ekle',
    removeChapter: 'Bölümü kaldır',
    popTitle: 'Pop quizler (video sırasında)',
    popHelp: 'Video belirlediğiniz anda durur ve soru sorulur.',
    popItem: 'Pop quiz #{{n}}',
    addPop: 'Pop quiz ekle',
    showAt: 'Gösterim anı (dk:sn)',
    finalTitle: 'Final sınavı (video sonunda)',
    finalHelp: 'Video tamamlandıktan sonra gösterilir; geçme puanı belirlenebilir.',
    finalItem: 'Soru #{{n}}',
    addFinal: 'Final sorusu ekle',
    passScore: 'Geçme puanı (%)',
    passScoreHint: 'Final sınavını geçmek için gereken doğru oranı.',
    question: 'Soru',
    questionPlaceholder: 'Soruyu yazın',
    optionsHint: 'Şıklar · doğru cevabın harfine dokunun',
    option: '{{letter}} şıkkı',
    markCorrect: '{{letter}} şıkkını doğru cevap yap',
    explanation: 'Açıklama',
    explanationPlaceholder: 'İsteğe bağlı · cevaptan sonra gösterilir',
    removeQuestion: 'Soruyu kaldır',
    targetGroups: 'Hedef gruplar',
    targetGroupsHint: 'Eğitim bu departmanlardaki çalışanların profilinde görünür.',
    deadlineToggle: 'Erişim için son tarih koy',
    deadlineHelp: 'Bu tarihten sonra eğitim “Süresi doldu” olarak işaretlenir.',
    deadline: 'Erişim son tarihi',
    summary: {
      heading: 'Özet',
      title: 'Başlık',
      instructor: 'Eğitmen',
      videoDuration: 'Video süresi',
      chapters: 'Bölüm sayısı',
      popQuizzes: 'Pop quiz sayısı',
      finalQuestions: 'Final sınavı soruları',
      passScore: 'Geçme puanı',
      groups: 'Hedef gruplar',
      deadline: 'Erişim son tarihi',
    },
    back: 'Geri',
    next: 'İleri',
    publish: 'Eğitimi Yayınla',
    publishing: 'Yayınlanıyor...',
    uploading: 'Video yükleniyor... %{{percent}}',
    saveChanges: 'Değişiklikleri Kaydet',
    toast: {
      created: 'Eğitim başarıyla oluşturuldu!',
      createError: 'Eğitim oluşturulurken bir hata oluştu',
      updated: 'Eğitim başarıyla güncellendi!',
      updateError: 'Eğitim güncellenirken bir hata oluştu',
      invalidVideo: 'Lütfen geçerli bir video dosyası seçin',
      oneChapter: 'En az bir bölüm olmalıdır',
    },
  },

  assignments: {
    title: 'Atama Görüntüleme',
    subtitle: 'SOP ve eğitim atamaları, son tarihler ve tamamlama durumu',
    help: 'Tüm SOP ve eğitim atamaları, atandıkları gruplarla birlikte listelenir. Son tarihi yaklaşanlar sarı, geçenler kırmızı işaretlenir.',
    helpManager: 'Tüm SOP ve eğitim atamaları listelenir. Her kartta kimlerin tamamladığını, kimlerin beklediğini görebilirsiniz. Son tarihi yaklaşanlar sarı, geçenler kırmızı işaretlenir.',
    search: 'Başlık veya grup ara...',
    filterLabel: 'Atama türü',
    filters: {
      all: 'Tümü',
      sop: 'SOP',
      education: 'Eğitim',
    },
    tiles: {
      total: 'Atama',
      dueSoon: 'Son tarihi yaklaşan',
      overdue: 'Süresi geçen',
    },
    empty: 'Görüntülenecek atama yok',
    noMatch: 'Filtreyle eşleşen atama bulunamadı',
    types: {
      sop: 'SOP',
      education: 'Eğitim',
    },
    assignedOn: 'Atama: {{date}}',
    dueDate: 'Son tarih',
    deadline: {
      none: 'son tarih yok',
      notSet: 'Belirlenmedi',
      overdue_one: '{{count}} gün gecikti',
      overdue_other: '{{count}} gün gecikti',
      today: 'bugün son gün',
      lastDay: 'yarın son gün',
      left_one: '{{count}} gün kaldı',
      left_other: '{{count}} gün kaldı',
    },
    done_one: '{{count}} tamamladı',
    done_other: '{{count}} tamamladı',
    pending_one: '{{count}} bekliyor',
    pending_other: '{{count}} bekliyor',
    total_one: '/ {{count}} kişi',
    total_other: '/ {{count}} kişi',
    doneList_one: 'Tamamlayanlar ({{count}})',
    doneList_other: 'Tamamlayanlar ({{count}})',
    pendingList_one: 'Bekleyenler ({{count}})',
    pendingList_other: 'Bekleyenler ({{count}})',
    noneDone: 'Henüz tamamlayan yok.',
    allDone: 'Herkes tamamladı.',
    audience: 'İlgili personel',
    version: 'Versiyon: {{value}}',
    approval: 'Onay: {{value}}',
    educationDate: 'Eğitim tarihi: {{value}}',
    toast: {
      loadError: 'Atama bilgileri alınırken bir hata oluştu',
    },
  },

  questionPool: {
    title: 'Soru Havuzu',
    subtitle: 'Departman bazlı okuma sonu sınav soruları',
    rules: 'Bir çalışan SOP veya eğitimi okuyup bitirdiğinde, kendi departmanının havuzu ile Ortak Havuz’dan rastgele sorular gelir. Pasif sorular sınavlarda çıkmaz.',
    questionCount: 'Sınavdaki soru sayısı',
    questionCountHint: '1–50 arası',
    passScore: 'Geçme puanı (%)',
    passScoreHint: '1–100 arası',
    saveSettings: 'Ayarları kaydet',
    departments: 'Departman havuzları',
    commonPool: 'Ortak Havuz (Hepsi)',
    commonHint: 'Bu sorular tüm departmanların sınavlarında kullanılabilir.',
    available_one: 'Sınavda sorulabilecek aktif soru: {{count}} (ortak havuz dahil)',
    available_other: 'Sınavda sorulabilecek aktif soru: {{count}} (ortak havuz dahil)',
    shortHint_one: 'Sınav için en az {{count}} aktif soru gerekir',
    shortHint_other: 'Sınav için en az {{count}} aktif soru gerekir',
    activeQuestions: 'Aktif soru sayısı',
    add: 'Soru ekle',
    empty: 'Bu havuzda henüz soru yok',
    emptyHint: '“Soru ekle” ile ilk soruyu oluşturun.',
    loadError: 'Sorular yüklenirken bir hata oluştu.',
    active: 'Aktif',
    inactive: 'Pasif',
    onHint: 'Sınavlarda kullanılıyor · pasife almak için dokunun',
    offHint: 'Sınavlarda kullanılmıyor · aktif etmek için dokunun',
    correct: 'Doğru cevap',
    deleteTitle: 'Soru silinsin mi?',
    deleteMessage: 'Bu soru havuzdan silinecek. Bu işlem geri alınamaz.',
    newTitle: 'Yeni soru',
    editTitle: 'Soruyu düzenle',
    question: 'Soru metni',
    questionPlaceholder: 'Soruyu yazın',
    optionsHint: 'Şıklar · doğru cevabın harfine dokunun',
    option: '{{letter}} şıkkı',
    markCorrect: '{{letter}} şıkkını doğru cevap yap',
    removeOption: '{{letter}} şıkkını kaldır',
    addOption: 'Şık ekle',
    explanation: 'Açıklama',
    explanationHint: 'İsteğe bağlı · sınavı geçen çalışana sonuç ekranında gösterilir.',
    explanationPlaceholder: 'Doğru cevabın neden doğru olduğunu kısaca yazın',
    errors: {
      question: 'Soru metni zorunludur',
      emptyOption: 'Boş şık bırakmayın; kullanmadığınız şıkkı silin',
      duplicate: 'Aynı şık birden fazla kez girilmiş',
    },
    toast: {
      settingsSaved: 'Sınav ayarları kaydedildi',
      settingsError: 'Sınav ayarları kaydedilemedi',
      added: 'Soru havuza eklendi',
      updated: 'Soru güncellendi',
      saveError: 'Soru kaydedilemedi',
      deleted: 'Soru silindi',
      deleteError: 'Soru silinemedi',
      toggleError: 'Soru durumu güncellenemedi',
    },
  },
};

export default quality;
